import type { AvatarFonts, AvatarSize } from "./types";

export const fontClassMap: Record<AvatarSize, AvatarFonts> = {
  xs: {
    letters: "text-xs font-medium",
    title: "text-xs font-normal",
    subtext: "text-xxs font-normal",
    skeletonImageSize: "w-6 h-6",
    skeletonTitleWidth: "w-20",
    skeletonTitleHeight: "h-[15px]",
    skeletonSubtextWidth: "w-[60px]",
    skeletonSubtextHeight: "h-[13px]",
  },
  sm: {
    letters: "text-sm font-medium",
    title: "text-sm font-normal",
    subtext: "text-xs font-normal",
    skeletonImageSize: "w-8 h-8",
    skeletonTitleWidth: "w-[100px]",
    skeletonTitleHeight: "h-[17px]",
    skeletonSubtextWidth: "w-20",
    skeletonSubtextHeight: "h-[15px]",
  },
  md: {
    letters: "text-md font-medium",
    title: "text-md font-medium",
    subtext: "text-sm font-normal",
    skeletonImageSize: "w-10 h-10",
    skeletonTitleWidth: "w-[120px]",
    skeletonTitleHeight: "h-[19px]",
    skeletonSubtextWidth: "w-[100px]",
    skeletonSubtextHeight: "h-[17px]",
  },
  lg: {
    letters: "text-lg font-medium",
    title: "text-lg font-medium",
    subtext: "text-md font-normal",
    skeletonImageSize: "w-12 h-12",
    skeletonTitleWidth: "w-[140px]",
    skeletonTitleHeight: "h-[23px]",
    skeletonSubtextWidth: "w-[120px]",
    skeletonSubtextHeight: "h-[19px]",
  },
  xl: {
    letters: "text-lg font-medium",
    title: "text-lg font-medium",
    subtext: "text-md font-normal",
    skeletonImageSize: "w-14 h-14",
    skeletonTitleWidth: "w-40",
    skeletonTitleHeight: "h-[23px]",
    skeletonSubtextWidth: "w-[140px]",
    skeletonSubtextHeight: "h-[19px]",
  },
  "2xl": {
    letters: "text-xl font-medium",
    title: "text-xl font-medium",
    subtext: "text-lg font-normal",
    skeletonImageSize: "w-16 h-16",
    skeletonTitleWidth: "w-[180px]",
    skeletonTitleHeight: "h-[27px]",
    skeletonSubtextWidth: "w-40",
    skeletonSubtextHeight: "h-[23px]",
  },
};
